<template>
  <div class="home">
    <img src="@/assets/aaaaa.png" />
    <div class="text">
      <a href="https://beian.miit.gov.cn/">备案号：浙ICP备20026348号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.text {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 6px 0;
}
</style>
